import { render, staticRenderFns } from "./SchoolName.vue?vue&type=template&id=d49036ca&scoped=true&"
import script from "./SchoolName.vue?vue&type=script&lang=js&"
export * from "./SchoolName.vue?vue&type=script&lang=js&"
import style0 from "./SchoolName.vue?vue&type=style&index=0&id=d49036ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49036ca",
  null
  
)

export default component.exports